import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function tenantreducer(state = initialState.Tenants, action) {
    switch (action.type) {

        case types.LOAD_TENANTS_LIST_SUCCESSFULL: 
        return {
            ...state,TenantsList: action.getResponse,
        };

        case types.TENANTNAMES_LIST_SUCCESSFULL:
        return{
            ...state,TenantNameList: action.getResponse
        }

        case types.GET_LICENSE:
        return {
            licensed : action.getResponse.licensedPanels,
        };

        case types.LOAD_TENANT_SUCCESSFULL: 
        return {
            TenantssList: action.getResponse,
            TenantToDisplay: state.TenantToDisplay,
            userDetails: state.userDetails,
            EmployeeDetails: state.EmployeeDetails
        };

        case types.SET_USER_ID: return {
            TenantsList: state.TenantsList,
            TenantToDisplay: {userID: action.userID},
            userDetails: action.userDetails
        };
        case types.SET_USER_IDS: return {
            ...state, TenantsForInvoice: {userIDs: action.userIDs}
        };
        case types.UPDATE_FIELD:return { 
            ...state, [action.key]: action.value };  

        case types.POST_SUCCESSFULL: return {
            TenantId: action.getResponse.data
        };  

        case types.GET_COST_SUCCESSFULL:
        return{
            ...state,Cost: action.getResponse
        };  

        

        default : return state; 
    }   
}

